import styled, { keyframes } from "styled-components";
import { colors } from "../contants";
import heroBackground from "../assets/yelkenHotel/IMG_4834.jpg";

const fadeUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const HeroWrapper = styled.div`
  background-image: linear-gradient(
      to bottom,
      rgba(6, 12, 34, 0.5),
      rgba(6, 12, 34, 0.82)
    ),
    url(${heroBackground});
  background-position: center 30%;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  margin: 0;
  padding: 0;
  overflow: hidden;
  position: relative;

  @media (max-width: 768px) {
    background-attachment: scroll;
  }
`;

export const HeroContainer = styled.div`
  width: 100%;
  min-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: clamp(1.75rem, 4vw, 3rem);
  padding: clamp(6rem, 12vw, 8rem) 1.5rem 4rem;
  text-align: center;

  @media (max-width: 600px) {
    min-height: 80vh;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  color: white;
  max-width: 700px;
  opacity: 0;
  animation: ${fadeUp} 0.9s ease 0.15s forwards;
`;

export const HeroLogoImage = styled.img`
  width: clamp(220px, 40vw, 460px);
  height: auto;
`;

export const HeroWelcomeText = styled.h3`
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: clamp(1rem, 2vw, 1.3rem);
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.9);
  max-width: 42ch;
  margin: 0 auto;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  opacity: 0;
  animation: ${fadeUp} 0.9s ease 0.45s forwards;
`;

export const VideoButton = styled.a`
  display: inline-block;
  color: ${(props) => (props.$active ? "black" : colors.textColor)};
  background-color: ${(props) =>
    props.$active ? colors.primaryColor : colors.dark300};
  font-size: 1.05rem;
  font-weight: 600;
  border-radius: 2rem;
  transition: background-color 0.3s ease, color 0.3s ease, transform 0.2s ease;
  padding: 0.95rem 2.75rem;
  cursor: pointer;

  @media only screen and (max-width: 600px) {
    padding: 0.85rem 2.25rem;
    font-size: 1rem;
  }

  ${(props) =>
    !props.$active &&
    `
    &:hover {
      background-color: ${colors.gold};
      color: white;
      transform: translateY(-2px);
    }
  `}
`;
